import { Box, Typography } from "@mui/material";
import TextWithExternalLink from "../../../../../../components/ExternalLink";
import SvgToIcon from "../../../../../../icons/SvgToIcon";
import IntegrationImage from "../../../../integrations/components/IntegrationImage";
import { logos } from "../../../icons/iconExport";

const ServerSecurityGroupsView = ({ entityData }) => {
  const awsRegion = entityData?.aws_data?.region;

  return (
    <Box display={"flex"} flexDirection={"column"} gap={1} marginBottom={5}>
      {entityData?.aws_data?.security_groups?.length > 0 &&
        entityData?.aws_data?.security_groups?.map((securityGroup) => (
          <Box
            key={securityGroup.name}
            display={"flex"}
            flexDirection={"column"}
            gap={1}
          >
            <Box
              display={"flex"}
              flexDirection={"row"}
              alignItems={"center"}
              gap={1}
            >
              <SvgToIcon IconLogo={logos.AWSLogo} width={"16px"} />
              {awsRegion && securityGroup.group_id ? (
                <TextWithExternalLink
                  text=""
                  linkText={securityGroup.name}
                  href={`https://${awsRegion}.console.aws.amazon.com/ec2/home?region=${awsRegion}#SecurityGroup:groupId=${securityGroup.group_id}`}
                />
              ) : (
                <Typography variant={"subtitle2"}>
                  {securityGroup.name}
                </Typography>
              )}
            </Box>
            {/* TODO: DEV-4676 */}
            {/* <Box display={"flex"} gap={1} flexDirection={"column"} ml={3}>
              {securityGroup?.tags?.length > 0 &&
                securityGroup?.tags?.map((tagObj, index) => (
                  <Box
                    key={index}
                    display={"flex"}
                    flexDirection={"column"}
                    gap={1}
                  >
                    {Object.entries(tagObj).map(([key, value]) => (
                      <TextIntegrationStyle
                        key={key}
                        title={key}
                        value={value}
                      ></TextIntegrationStyle>
                    ))}
                  </Box>
                ))}
            </Box> */}
          </Box>
        ))}
      {entityData?.azure_vm_data?.security_groups?.length > 0 &&
        entityData?.azure_vm_data?.security_groups?.map((securityGroup) => (
          <Box
            key={securityGroup.name}
            display={"flex"}
            flexDirection={"column"}
            gap={1}
          >
            <Box
              display={"flex"}
              flexDirection={"row"}
              alignItems={"center"}
              gap={1}
            >
              <IntegrationImage name={"azure"} width={"16px"} newLogo={true} />
              <Typography variant={"subtitle2"}>
                {securityGroup.name}
              </Typography>
            </Box>
          </Box>
        ))}
      {entityData?.microsoft_sccm_data?.security_groups?.length > 0 &&
        entityData?.microsoft_sccm_data?.security_groups?.map(
          (securityGroup) => (
            <Box
              key={securityGroup}
              display={"flex"}
              flexDirection={"column"}
              gap={1}
            >
              <Box
                display={"flex"}
                flexDirection={"row"}
                alignItems={"center"}
                gap={1}
              >
                <IntegrationImage
                  name={"microsoft_sccm"}
                  width={"16px"}
                  newLogo={true}
                />
                <Typography variant={"subtitle2"}>{securityGroup}</Typography>
              </Box>
            </Box>
          )
        )}
    </Box>
  );
};

export default ServerSecurityGroupsView;
